module.exports = __webpack_public_path__ + "static/media/AICDMB_invitation.6c51f68e.pdf";